module.exports = __webpack_public_path__ + "static/beauty-counter-ebfb85c9117c007c642dacccba7cf204.png";